import { QueryHookOptions, useQuery } from '@apollo/client';

import apiUserValidQuery from './caseAdminUrls.graphql';

export default function useCaseAdminUrlsQuery(
  options?: QueryHookOptions<CaseAdminUrlsQuery, CaseAdminUrlsQueryVariables>,
) {
  return useQuery<CaseAdminUrlsQuery, CaseAdminUrlsQueryVariables>(
    apiUserValidQuery,
    options,
  );
}
